const ENV = {
    development: {
      baseUrl: "https://e2e.beedatatech.com",
    },
    production: {
      baseUrl: "https://e2e.beedatatech.com",
    },
  };
  
  const currentEnv = process.env.REACT_APP_ENV || "development";
  
  export const baseUrl = ENV[currentEnv].baseUrl;

  export const baseUrlImg = `https://e2e.beedatatech.com`;
  
